// 计算当前年龄
function computingAge(val) {
  const oldTime = new Date(val)
  const yearBirth = oldTime.getFullYear()
  const monthBirth = oldTime.getMonth() + 1
  const dayBirth = oldTime.getDate()
  const nowDate = new Date()
  const monthNow = nowDate.getMonth() + 1
  const dayNow = nowDate.getDate()
  let age = nowDate.getFullYear() - yearBirth

  if (
    monthNow < monthBirth ||
    (monthNow === monthBirth && dayNow < dayBirth)
  ) {
    age--
  }
  return age
}

export default computingAge